// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".combo-img[data-v-37e06c0e]{border-radius:10px;border:2px solid #979797;height:auto;width:100%}.collapsed>.when-open[data-v-37e06c0e],.not-collapsed>.when-closed[data-v-37e06c0e]{display:none}.quantity-select[data-v-37e06c0e]{width:6.5em}", ""]);
// Exports
module.exports = exports;
